import React, { useState, useEffect } from 'react';
import Menu from '../../elements/Menu/menu';
import CheckAuth from '../../elements/checkAuth';
import Loader from '../../elements/Loader/loader';
import ModalWindow from '../../elements/ModalWindow/modal';
import '../../../../styles/table.admin.css';
import './exchangeWaysMatrix.css';
import trusteeLogo from '../../../../images/logoDark.png';
import config from '../../../../config/environment';
import axios from 'axios';

export default function ReportByPeriod() {
    const [state, setState] = useState({
        // matrix: null,
        tableHead: null,
        tableRows: null,
        providersArray: null,
        moreInfoProviderDataArray: null,

        inCurrencyFilter: null,
        outCurrencyFilter: null,
        providerFilter: 'DEFAULT',

        loader: false,
        isShowModal: false
    });

    useEffect(() => {
        const main = async () => {
            const preRequestData = await preRequest();
            setState(state => { return {
                ...state,
                providersArray: preRequestData.providersArray
            }; });
        };
        main();
    }, []);

    const preRequest = async () => {
        try {
            const response = await axios.get(config.backendUrl + '/data/all-admin-prerequest', { headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
            } });
            // console.log(response.data); // for debugging
            return response.data;

        } catch (error) {
            console.log(error.message);
            console.log(error.response.data.message);
            alert(error.response.data.message);
        }
    };

    const getMatrix = async () => {
        try {
            let params = '?';
            if (state.inCurrencyFilter) {
                params += 'inCurrencyCode=' + state.inCurrencyFilter + '&';
            }
            if (state.outCurrencyFilter) {
                params += 'outCurrencyCode=' + state.outCurrencyFilter + '&';
            }
            if (state.providerFilter !== 'DEFAULT') {
                params += 'providerName=' + state.providerFilter + '&';
            }
    
            const url = config.backendUrl + '/data/exchange-ways-matrix' + params.slice(0, -1);
            // console.log(url); // for debugging

            const response = await axios.get(url, { headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
            } });
            console.log(response.data); // for debugging
            return response.data;

        } catch (error) {
            console.log(error.message);
            console.log(error.response.data.message);
            alert(error.response.data.message);
        }
    };

    const formTable = (matrix) => {
        let tableHead = [];
        const tableRows = [];
        let outCurrenciesArray = [];
        let tmpRow = [];
        let waysArray;

        matrix.map(wayData => {
            tableHead.push(wayData.inCurrencyCode);
            outCurrenciesArray.push(wayData.outCurrencyCode);
        });

        tableHead = Array.from(new Set(tableHead));
        outCurrenciesArray = Array.from(new Set(outCurrenciesArray));

        for (let i = 0; i < outCurrenciesArray.length; i++) {
            tmpRow.push(outCurrenciesArray[i]);

            for (let j = 0; j < tableHead.length; j++) {
                if (tableHead[j] === outCurrenciesArray[i]) { tmpRow.push('/'); continue; }
                waysArray = matrix.filter(wayData => wayData.inCurrencyCode === tableHead[j] && wayData.outCurrencyCode === outCurrenciesArray[i]);
                if (waysArray.length) {
                    tmpRow.push(waysArray.map(wayData => {
                        return {
                            providerName: wayData.providerName,
                            inPaywayCode: wayData.inPaywayCode,
                            outPaywayCode: wayData.outPaywayCode,
                            isIntegrated: wayData.isIntegrated
                        }
                    }));
                }
                else { tmpRow.push('-'); }
            }

            tableRows.push(tmpRow);
            tmpRow = [];
        }

        console.log(tableHead); // for debugging
        console.log(tableRows); // for debugging

        return { tableHead, tableRows };
    };

    const filterChangeHandler = (filterType) => (event) => {
        const newState = { ...state };
        newState[ filterType + 'Filter' ] = event.target.value;
        setState(() => { return newState; });
    };

    const findButtonHandler = async () => {
        try {
            if (!state.inCurrencyFilter && !state.outCurrencyFilter && state.providerFilter === 'DEFAULT') {
                return alert('Empty filters');
            }

            setState(state => { return { ...state, loader: true }; });

            const matrix = await getMatrix();
            const { tableHead, tableRows } = formTable(matrix);
    
            setState(state => { return {
                ...state,
                // matrix,
                tableHead,
                tableRows,
                loader: false
            }; });
        } catch (error) {
            setState(state => { return { ...state, loader: false }; });
        }
    };

    const providerInfoButtonHandler = (providerDataArray) => () => {
        providerDataArray && providerDataArray.length ?
        setState(state => { return {
            ...state,
            isShowModal: true,
            moreInfoProviderDataArray: providerDataArray
        }; })
        :
        setState(state => { return { ...state, isShowModal: false, moreInfoProviderDataArray: null }; });
    };

    const renderFilters = () => {
        if (!state.providersArray) { return; }

        return(
            <div className="exchangeWays__filters_wrapper">
                <input className="exchangeWays__providerFee_wrapper" value={ state.inCurrencyFilter || '' } onChange={ filterChangeHandler('inCurrency') }
                    type="text" placeholder="in currency" />
                <input className="exchangeWays__providerFee_wrapper" value={ state.outCurrencyFilter || '' } onChange={ filterChangeHandler('outCurrency') }
                    type="text" placeholder="out currency" />

                <select className="exchangeWays__providerFee_wrapper" value={ state.providerFilter } onChange={ filterChangeHandler('provider') }>
                    <option value="DEFAULT">provider</option>
                    {
                        state.providersArray ? state.providersArray.map(providerName => {
                            return(<option value={ providerName }>{ providerName }</option>);
                        }) : null
                    }
                </select>

                <button onClick={ findButtonHandler }>Find</button>
            </div>
        );
    };

    const renderTable = () => {
        if (!state.tableHead || !state.tableHead.length || !state.tableRows || !state.tableRows.length) { return; }
        let tmpProviders;

        return(
            <div className="exchangeWaysMatrix__table_wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th>OUT \ IN</th>
                            { state.tableHead.map(column => <th>{ column }</th>) }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            state.tableRows.map(row => {
                                return(
                                    <tr>
                                        {
                                            row.map((element, index) => {
                                                tmpProviders = [];
                                                if (index === 0) { return(<th>{ element }</th>); }
                                                return(
                                                    <td>
                                                        { 
                                                            typeof element === 'string' ?
                                                            element :
                                                            <>
                                                                {
                                                                    element.map(providerData => {
                                                                        if (tmpProviders.includes(providerData.providerName)) { return; }
                                                                        tmpProviders.push(providerData.providerName);

                                                                        const providerWays = element.filter(tmpProviderData => tmpProviderData.providerName === providerData.providerName);
                                                                        if (providerWays.length > 1) {
                                                                            return(
                                                                                <div className="exchangeWaysMatrix__providerData_wrapper">
                                                                                    { providerData.providerName.toLowerCase() }
                                                                                    <button className="exchangeWaysMatrix__providerData_button" onClick={ providerInfoButtonHandler(providerWays) } >i</button>
                                                                                </div>
                                                                            );
                                                                        }

                                                                        return(
                                                                            <div className="exchangeWaysMatrix__providerData_wrapper">
                                                                                { providerData.providerName.toLowerCase() }
                                                                                { providerData.isIntegrated ?
                                                                                    <img className="exchangeWaysMatrix__providerData_logo" src={trusteeLogo} alt="Logo" /> : null }
                                                                            </div>
                                                                        );
                                                                    })
                                                                }
                                                            </>    
                                                        }
                                                    </td>
                                                );
                                            })
                                        }
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    };

    const renderModal = () => {
        if (!state.moreInfoProviderDataArray || !state.moreInfoProviderDataArray.length) { return; }

        return(
            <>
                <ModalWindow show={ state.isShowModal } close={ providerInfoButtonHandler() } headerText={ state.moreInfoProviderDataArray[0].providerName }>
                    <div className="orderInfo__modal_header">Payways</div>
                    {
                        state.moreInfoProviderDataArray.map(providerData => {
                            return(
                                <div className="exchangeWaysMatrix__modal_row">
                                    { providerData.inPaywayCode + ' -> ' + providerData.outPaywayCode }
                                    { providerData.isIntegrated ? <img className="exchangeWaysMatrix__providerData_logo" src={trusteeLogo} alt="Logo" /> : null }
                                </div>
                            );
                        })
                    }
                    <hr />
                </ModalWindow>
            </>
        );
    }

    return(
        <>
            <CheckAuth />
            <Menu />
            <div>
                { renderFilters() }
                <Loader loader={ state.loader } />
                { renderTable() }
                { renderModal() }
            </div>
        </>
    );
};